<template>
    <div class="popup_st03" >
        <div class="popup_wrap">
            <div class="title"><span class="t02">{{ rdName }}</span></div>
            <div class="text">
                <span class="pop_bt_state blue">구간</span>
                <span v-show="spName != '' && epName != ''">{{ spName }} ~ {{ epName }}(구간거리: {{ distance }}m)</span>
            </div>
            <div class="traffic_box">
                <p :class="[clazz]">
                    <span class="txt01">{{ state }}</span>
                    <span class="txt01">{{ speed }}</span><span class="txt02">km/h</span>
                </p>
            </div>
        </div>
        
        <div class="pop_bt_close"><a href="#" class="self-close-btn">닫기</a></div>
        <div class="pop_bt_close2"><a href="#" class="self-close-btn">닫기</a></div>
    </div>
</template>

<script>
module.exports = {
    data: function() {
        return {
            trafficInfo: {}
        };
    },
    computed: {
        rdName: function() {
            return this.trafficInfo.ROAD_NM;
        },
        spName: function() {
            return this.trafficInfo.START_ND_NM;
        },
        epName: function() {
            return this.trafficInfo.END_ND_NM;
        },
        speed: function() {
            return this.trafficInfo.SPD;
        },
        state: function() {
            return this.trafficInfo.IDX;
        },
        clazz: function() {
            if(this.trafficInfo.IDX === '원활') {
                return 't_green';
            } else if(this.trafficInfo.IDX === '서행') {
                return 't_yellow';
            } else if(this.trafficInfo.IDX === '정체') {
                return 't_red';
            }
        },
        distance: function() {
            return this.trafficInfo.DIST;
        },
    }, 
    
    updated: function() {
        this.$emit('loaded-traffic-info', this.$el.innerHTML);
    },
    
    methods: {
        setTrafficInfo: function(trafficInfo) {
            this.trafficInfo = Object.assign({}, trafficInfo);
        }
    }
}
</script>

<style>

</style>